import { ModeloBase } from "./modeloBase"


export class ModeloSopProduction extends ModeloBase {
  cod_tela_sop_production?: number;
  des_time?: string;
  cod_business_unit?: number;
  cod_plant?: number;
  cod_product?: number;

  num_packaging_real_units?: number;
  num_packaging_forecast_units?: number;
  num_packaging_budget_units?: number;

  num_flavor_real_units?: number;
  num_flavor_forecast_units?: number;
  num_flavor_budget_units?: number;

  num_drying_real_units?: number;
  num_drying_forecast_units?: number;
  num_drying_budget_units?: number;

  num_blending_real_units?: number;
  num_blending_forecast_units?: number;
  num_blending_budget_units?: number;

  num_total_production_real_usd?: number;
  num_total_production_forecast_usd?: number;
  num_total_production_budget_usd?: number;

  num_total_production_unitcost_real?: number;
  num_total_production_unitcost_forecast?: number;
  num_total_production_unitcost_budget?: number;

  sa?: number;
  num_total_production_unitcost_real_dup?: number;

  des_product?: string;
  des_product_family?: string;
  des_industrial_plant?: string;
  des_business_unit?: string;

}
